import type { ZoneStatus } from '@jq4race/shared';

export const STATUS_TONE: Record<ZoneStatus, 'success' | 'secondary'> = {
  active: 'success',
  inactive: 'secondary',
};
